// Bundled EMS UI labels. Operator-entered titles, names and notes remain data.
const entries: ReadonlyArray<readonly [string, string, string]> = [
  ["Property", "Hotel", "Hotel"],
  ["Engineering Control Center", "Technische Betriebszentrale", "Centrum obsługi technicznej"],
  ["Hotel engineering, work orders, preventive maintenance, SLA and room availability blocks.", "Haustechnik, Arbeitsaufträge, vorbeugende Wartung, SLA und Zimmersperren.", "Obsługa techniczna hotelu, zlecenia, konserwacja zapobiegawcza, SLA i blokady dostępności pokoi."],
  ["Live Board", "Live-Übersicht", "Tablica bieżąca"],
  ["Work Orders", "Arbeitsaufträge", "Zlecenia"],
  ["Preventive", "Vorbeugende Wartung", "Konserwacja zapobiegawcza"],
  ["Assets & Rooms", "Anlagen und Zimmer", "Urządzenia i pokoje"],
  ["SLA & Performance", "SLA und Leistung", "SLA i wydajność"],
  ["Reports", "Berichte", "Raporty"],
  ["Settings", "Einstellungen", "Ustawienia"],
  ["New issue", "Neue Störung", "Nowa usterka"],
  ["Set room out of order", "Zimmer außer Betrieb setzen", "Wyłącz pokój z eksploatacji"],
  ["Preventive Task", "Wartungsaufgabe", "Zadanie konserwacyjne"],
  ["Missing permission: {{permission}}", "Fehlende Berechtigung: {{permission}}", "Brak uprawnień: {{permission}}"],
  ["Engineering Live Board", "Live-Übersicht der Haustechnik", "Tablica obsługi technicznej"],
  ["Operations hub for engineering, SLA and room status.", "Betriebsübersicht für Haustechnik, SLA und Zimmerstatus.", "Centrum operacyjne obsługi technicznej, SLA i statusów pokoi."],
  ["Live", "Live", "Na żywo"],
  ["Today", "Heute", "Dzisiaj"],
  ["Open Work Orders", "Offene Arbeitsaufträge", "Otwarte zlecenia"],
  ["Active", "Aktiv", "Aktywne"],
  ["Critical Issues", "Kritische Störungen", "Usterki krytyczne"],
  ["Immediate", "Sofort", "Natychmiast"],
  ["OOO Rooms", "Zimmer außer Betrieb", "Pokoje wyłączone z eksploatacji"],
  ["Out of Order", "Außer Betrieb", "Wyłączony z eksploatacji"],
  ["OOS Rooms", "Vorübergehend gesperrte Zimmer", "Pokoje czasowo wyłączone"],
  ["Out of Service", "Vorübergehend gesperrt", "Czasowo wyłączony"],
  ["SLA Breaches", "SLA-Verletzungen", "Naruszenia SLA"],
  ["Blocking", "Blockierend", "Blokujące"],
  ["Tasks Today", "Heutige Aufgaben", "Zadania na dziś"],
  ["Queue", "Warteschlange", "Kolejka"],
  ["Preventive Due", "Fällige Wartungen", "Konserwacje do wykonania"],
  ["PM", "Vorbeugende Wartung", "Konserwacja zapobiegawcza"],
  ["Avg Resolution", "Ø Behebungszeit", "Średni czas usunięcia usterki"],
  ["Last 30d", "Letzte 30 Tage", "Ostatnie 30 dni"],
  ["Immediate attention required.", "Sofortiges Handeln erforderlich.", "Wymagana natychmiastowa interwencja."],
  ["No critical issues", "Keine kritischen Störungen", "Brak usterek krytycznych"],
  ["Work Orders by Status", "Arbeitsaufträge nach Status", "Zlecenia według statusu"],
  ["Open / In progress / Waiting / Completed.", "Offen / In Bearbeitung / Wartend / Abgeschlossen.", "Otwarte / W realizacji / Oczekujące / Zakończone."],
  ["Rooms Affected", "Betroffene Zimmer", "Pokoje objęte usterkami"],
  ["Out-of-order, blocked, and in-house impact.", "Auswirkungen auf defekte und gesperrte Zimmer sowie anwesende Gäste.", "Wpływ na pokoje wyłączone, zablokowane i zajęte przez gości."],
  ["Room {{number}}", "Zimmer {{number}}", "Pokój {{number}}"],
  ["No rooms impacted", "Keine Zimmer betroffen", "Brak pokoi objętych usterkami"],
  ["Technician Workload", "Technikerauslastung", "Obciążenie pracowników technicznych"],
  ["Open tasks by technician.", "Offene Aufgaben je Techniker.", "Otwarte zadania według pracownika technicznego."],
  ["SLA Warning Panel", "SLA-Warnungen", "Ostrzeżenia SLA"],
  ["Items nearing breach.", "Aufträge kurz vor einer SLA-Verletzung.", "Zlecenia z zagrożonym terminem SLA."],
  ["Due soon", "Bald fällig", "Termin wkrótce"],
  ["No SLA warnings", "Keine SLA-Warnungen", "Brak ostrzeżeń SLA"],
  ["Quick Actions", "Schnellaktionen", "Szybkie działania"],
  ["Quick engineering workflows.", "Schnelle Abläufe für die Haustechnik.", "Szybkie działania obsługi technicznej."],
  ["Report new issue", "Neue Störung melden", "Zgłoś nową usterkę"],
  ["Edit asset", "Anlage bearbeiten", "Edytuj urządzenie"],
  ["Public Area", "Öffentlicher Bereich", "Część ogólnodostępna"],
  ["Unassigned", "Nicht zugewiesen", "Nieprzypisane"],
  ["Tickets, SLA, status workflows and room availability logic.", "Tickets, SLA, Statusabläufe und Zimmerverfügbarkeit.", "Zgłoszenia, SLA, zmiany statusów i dostępność pokoi."],
  ["Create Ticket", "Ticket erstellen", "Utwórz zgłoszenie"],
  ["Issue Title", "Störungsbezeichnung", "Tytuł usterki"],
  ["AC not cooling", "Klimaanlage kühlt nicht", "Klimatyzacja nie chłodzi"],
  ["Room", "Zimmer", "Pokój"],
  ["Category", "Kategorie", "Kategoria"],
  ["Priority", "Priorität", "Priorytet"],
  ["Assign To", "Zuweisen an", "Przypisz do"],
  ["Create Work Order", "Arbeitsauftrag erstellen", "Utwórz zlecenie"],
  ["Reset", "Zurücksetzen", "Wyczyść"],
  ["Work Order", "Arbeitsauftrag", "Zlecenie"],
  ["Area", "Bereich", "Obszar"],
  ["Status", "Status", "Status"],
  ["SLA", "SLA", "SLA"],
  ["Assigned", "Zugewiesen an", "Przypisano do"],
  ["Actions", "Aktionen", "Działania"],
  ["In-house", "Gast im Haus", "Gość zameldowany"],
  ["Assign", "Zuweisen", "Przypisz"],
  ["Start", "Starten", "Rozpocznij"],
  ["Wait", "Warten", "Wstrzymaj"],
  ["Complete", "Abschließen", "Zakończ"],
  ["Preventive Maintenance", "Vorbeugende Wartung", "Konserwacja zapobiegawcza"],
  ["Asset-based plans, schedules, overdue tracking.", "Anlagenbezogene Pläne, Wartungsintervalle und überfällige Aufgaben.", "Plany dla urządzeń, harmonogramy i kontrola zaległych zadań."],
  ["Create Plan", "Plan erstellen", "Utwórz plan"],
  ["Upcoming Plans", "Anstehende Wartungen", "Nadchodzące konserwacje"],
  ["Weekly, monthly, quarterly schedules.", "Wöchentliche, monatliche und vierteljährliche Wartungen.", "Harmonogramy tygodniowe, miesięczne i kwartalne."],
  ["No preventive plans for this property yet", "Noch keine Wartungspläne für dieses Hotel", "Brak planów konserwacji dla tego hotelu"],
  ["Auto Task Creation", "Automatische Aufgabenerstellung", "Automatyczne tworzenie zadań"],
  ["Automatic work order generation.", "Automatische Erstellung von Arbeitsaufträgen.", "Automatyczne tworzenie zleceń."],
  ["Weekly checks", "Wöchentliche Kontrollen", "Kontrole tygodniowe"],
  ["Monthly inspections", "Monatliche Inspektionen", "Inspekcje miesięczne"],
  ["Quarterly audits", "Vierteljährliche Audits", "Audyty kwartalne"],
  ["Enabled", "Aktiviert", "Włączone"],
  ["Asset registry, room technical status and health indicators.", "Anlagenverzeichnis, technischer Zimmerstatus und Zustandsanzeigen.", "Rejestr urządzeń, stan techniczny pokoi i wskaźniki sprawności."],
  ["Add Asset", "Anlage hinzufügen", "Dodaj urządzenie"],
  ["Assets", "Anlagen", "Urządzenia"],
  ["HVAC, elevators, boilers, IT hardware.", "Heizungs-, Lüftungs- und Klimaanlagen, Aufzüge, Heizkessel und IT-Geräte.", "Klimatyzacja, wentylacja, windy, kotły i sprzęt IT."],
  ["Asset", "Anlage", "Urządzenie"],
  ["Location", "Standort", "Lokalizacja"],
  ["Type", "Typ", "Typ"],
  ["Health", "Zustand", "Sprawność"],
  ["No assets for this property yet", "Noch keine Anlagen für dieses Hotel", "Brak urządzeń dla tego hotelu"],
  ["Empty", "Leer", "Brak danych"],
  ["Room Technical Status", "Technischer Zimmerstatus", "Stan techniczny pokoi"],
  ["Availability alignment with PMS.", "Abgleich der Verfügbarkeit mit dem PMS.", "Zgodność dostępności z PMS."],
  ["Response time, breach tracking, escalation log.", "Reaktionszeit, SLA-Verletzungen und Eskalationsprotokoll.", "Czas reakcji, kontrola naruszeń SLA i historia eskalacji."],
  ["Export SLA", "SLA exportieren", "Eksportuj SLA"],
  ["Avg Response", "Ø Reaktionszeit", "Średni czas reakcji"],
  ["MTD", "Laufender Monat", "Bieżący miesiąc"],
  ["Open", "Offen", "Otwarte"],
  ["Completion Rate", "Abschlussquote", "Wskaźnik realizacji"],
  ["Technician Performance", "Technikerleistung", "Wydajność pracowników technicznych"],
  ["Tickets resolved and response time.", "Erledigte Tickets und Reaktionszeit.", "Rozwiązane zgłoszenia i czas reakcji."],
  ["Resolved {{count}} · Avg {{duration}}", "Erledigt: {{count}} · Ø {{duration}}", "Rozwiązane: {{count}} · Średnio {{duration}}"],
  ["Escalation Log", "Eskalationsprotokoll", "Historia eskalacji"],
  ["Breach tracking and escalations.", "SLA-Verletzungen und Eskalationen.", "Kontrola naruszeń SLA i eskalacji."],
  ["{{order}} escalated", "{{order}} eskaliert", "Eskalowano {{order}}"],
  ["{{order}} breach warning", "{{order}}: Warnung vor SLA-Verletzung", "{{order}}: ostrzeżenie o zagrożeniu SLA"],
  ["GM notified", "Hoteldirektion benachrichtigt", "Powiadomiono dyrekcję hotelu"],
  ["Supervisor", "Vorgesetzter", "Przełożony"],
  ["Work Orders by Category", "Arbeitsaufträge nach Kategorie", "Zlecenia według kategorii"],
  ["Preventive Compliance", "Einhaltung der Wartungspläne", "Realizacja planów konserwacji"],
  ["Room Availability Summary", "Übersicht der Zimmerverfügbarkeit", "Podsumowanie dostępności pokoi"],
  ["Operations and engineering KPI exports.", "KPI-Exporte für Betrieb und Haustechnik.", "Eksport wskaźników operacyjnych i technicznych."],
  ["Export Center", "Exportzentrale", "Centrum eksportu"],
  ["SLA rules, categories, escalation matrix.", "SLA-Regeln, Kategorien und Eskalationsmatrix.", "Reguły SLA, kategorie i macierz eskalacji."],
  ["Edit Rules", "Regeln bearbeiten", "Edytuj reguły"],
  ["SLA Rules", "SLA-Regeln", "Reguły SLA"],
  ["Priority-based response windows.", "Reaktionsfristen nach Priorität.", "Czasy reakcji według priorytetu."],
  ["Critical", "Kritisch", "Krytyczny"],
  ["High", "Hoch", "Wysoki"],
  ["Medium", "Mittel", "Średni"],
  ["Low", "Niedrig", "Niski"],
  ["Response within {{duration}}", "Reaktion innerhalb von {{duration}}", "Reakcja w ciągu {{duration}}"],
  ["Categories", "Kategorien", "Kategorie"],
  ["HVAC, plumbing, electrical, IT.", "Heizung, Lüftung, Klima, Sanitär, Elektrik und IT.", "Klimatyzacja i wentylacja, hydraulika, elektryka i IT."],
  ["HVAC", "Heizung, Lüftung und Klima", "Klimatyzacja i wentylacja"],
  ["Plumbing", "Sanitär", "Hydraulika"],
  ["Electrical", "Elektrik", "Elektryka"],
  ["IT", "IT", "IT"],
  ["General", "Allgemein", "Ogólne"],
  ["Elevator", "Aufzug", "Winda"],
  ["Boiler", "Heizkessel", "Kocioł"],
  ["Boiler inspection", "Heizkesselinspektion", "Przegląd kotła"],
  ["Elevator safety", "Aufzugssicherheit", "Kontrola bezpieczeństwa windy"],
  ["HVAC filter swap", "Filterwechsel der Klimaanlage", "Wymiana filtrów klimatyzacji"],
  ["AC Unit 402", "Klimagerät 402", "Klimatyzator 402"],
  ["Elevator A", "Aufzug A", "Winda A"],
  ["Main Boiler", "Hauptheizkessel", "Kocioł główny"],
  ["WiFi AP Lobby", "WLAN-Zugangspunkt Lobby", "Punkt Wi-Fi w holu"],
  ["Core", "Gebäudekern", "Trzon budynku"],
  ["Basement", "Keller", "Piwnica"],
  ["Lobby", "Lobby", "Hol"],
  ["Untitled work order", "Arbeitsauftrag ohne Titel", "Zlecenie bez tytułu"],
  ["Preventive maintenance task", "Wartungsaufgabe", "Zadanie konserwacyjne"],
  ["Unnamed asset", "Unbenannte Anlage", "Urządzenie bez nazwy"],
  ["Unknown location", "Unbekannter Standort", "Nieznana lokalizacja"],
  ["Unassigned area", "Nicht zugewiesener Bereich", "Nieprzypisany obszar"],
  ["Technician {{number}}", "Techniker {{number}}", "Pracownik techniczny {{number}}"],
  ["status.open", "Offen", "Otwarte"],
  ["status.assigned", "Zugewiesen", "Przypisane"],
  ["status.in_progress", "In Bearbeitung", "W realizacji"],
  ["status.waiting_parts", "Warten auf Ersatzteile", "Oczekiwanie na części"],
  ["status.completed", "Abgeschlossen", "Zakończone"],
  ["status.verified", "Geprüft", "Zweryfikowane"],
  ["status.clean", "Sauber", "Czysty"],
  ["status.dirty", "Schmutzig", "Brudny"],
  ["status.inspected", "Kontrolliert", "Sprawdzony"],
  ["status.available", "Verfügbar", "Dostępny"],
  ["status.blocked", "Gesperrt", "Zablokowany"],
  ["status.out_of_order", "Außer Betrieb", "Wyłączony z eksploatacji"],
  ["status.out_of_service", "Vorübergehend gesperrt", "Czasowo wyłączony"],
  ["status.unknown", "Unbekannt", "Nieznany"],
  ["status.due", "Fällig", "Do wykonania"],
  ["status.scheduled", "Geplant", "Zaplanowane"],
  ["status.overdue", "Überfällig", "Zaległe"],
  ["status.good", "Gut", "Dobry"],
  ["status.warn", "Warnung", "Ostrzeżenie"],
  ["status.critical", "Kritisch", "Krytyczny"],
  ["schedule.weekly", "Wöchentlich", "Co tydzień"],
  ["schedule.monthly", "Monatlich", "Co miesiąc"],
  ["schedule.quarterly", "Vierteljährlich", "Co kwartał"],
  ["schedule.yearly", "Jährlich", "Co rok"],
];
const englishLabels: Record<string, string> = {
  "status.open": "Open", "status.assigned": "Assigned", "status.in_progress": "In progress",
  "status.waiting_parts": "Waiting for parts", "status.completed": "Completed", "status.verified": "Verified",
  "status.clean": "Clean", "status.dirty": "Dirty", "status.inspected": "Inspected", "status.available": "Available",
  "status.blocked": "Blocked", "status.out_of_order": "Out of order", "status.out_of_service": "Out of service",
  "status.unknown": "Unknown", "status.due": "Due", "status.scheduled": "Scheduled", "status.overdue": "Overdue",
  "status.good": "Good", "status.warn": "Warning", "status.critical": "Critical",
  "schedule.weekly": "Weekly", "schedule.monthly": "Monthly", "schedule.quarterly": "Quarterly", "schedule.yearly": "Yearly",
};
export const emsResources = {
  en: { ...Object.fromEntries(entries.map(([en]) => [en, englishLabels[en] ?? en])), openOrders_one: "{{count}} open work order", openOrders_other: "{{count}} open work orders" },
  de: { ...Object.fromEntries(entries.map(([en, de]) => [en, de])), openOrders_one: "{{count}} offener Arbeitsauftrag", openOrders_other: "{{count}} offene Arbeitsaufträge" },
  pl: { ...Object.fromEntries(entries.map(([en, , pl]) => [en, pl])), openOrders_one: "{{count}} otwarte zlecenie", openOrders_few: "{{count}} otwarte zlecenia", openOrders_many: "{{count}} otwartych zleceń", openOrders_other: "{{count}} otwartego zlecenia" },
};
